/**
 * 会员状态
 */
export enum MemberStatus {
  Active = 'Active',
  Expired = 'Expired',
  Suspended = 'Suspended'
}

/**
 * 会员信息
 */
export interface MembershipDto {
  id: string
  userId: string
  memberNumber: string
  status: MemberStatus
  effectiveDate?: string
  expireDate?: string
  totalRenewalCount: number
  lastRenewalDate?: string
  totalPaidAmount: number
  creationTime: string
  lastModificationTime?: string
}

/**
 * 延长会员有效期输入参数
 */
export interface ExtendMembershipInput {
  months: number
  remark?: string
}

/**
 * 获取会员列表查询参数
 */
export interface MembershipQuery {
  filter?: string
  status?: MemberStatus
  skipCount?: number
  maxResultCount?: number
  sorting?: string
}
